import React from 'react';

import Error500 from './Error500';
import PropTypes from 'prop-types';

function FallBack({ error }) {
  return <Error500 error={error} />;
}

FallBack.propTypes = {
  error: PropTypes.number.isRequired,
};

export default FallBack;
